import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import strings from 'strings';
import { FPActionButton, FPIcon, TextBox } from 'UI/components/atoms';
import { SvgMakeAi } from 'UI/res';

import {
  DividerStyled,
  useProspectingAssistantModalStyles
} from './AIProspectingAssistantModal.styled';

const GRADIENT_TEXT_COLOR = '#8872F0';
const COPIES = strings.ai.generators.prospectingAssistant.modal;

export const AIProspectingAssistantModal = ({
  location,
  onClose,
  onExecuteSearch,
  open,
  title
}) => {
  const classes = useProspectingAssistantModalStyles();
  const [searchText, setSearchText] = useState(
    strings.formatString(COPIES.searchTextTemplate, { title, location })
  );
  const canGoSearch = !!searchText.trim();

  const handleClose = (_event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;

    onClose && onClose();
  };

  const handleExecuteSearch = () => {
    const trimmedSearchText = searchText.trim();
    if (!trimmedSearchText) return;

    handleClose();
    onExecuteSearch && onExecuteSearch(trimmedSearchText);
  };

  const handleTextChange = (_name, text) => {
    setSearchText(text);
  };

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      fullWidth
      maxWidth="md"
      onClose={handleClose}
      open={open}
      scroll="paper"
    >
      <Box className={classes.header}>
        <Box alignItems="center" display="flex" flexDirection="row" gridGap={8}>
          <FPIcon color={GRADIENT_TEXT_COLOR} component={SvgMakeAi} size={40} />
          <Typography variant="h5">{COPIES.title}</Typography>
        </Box>
        <IconButton size="small" onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent className={classes.dialogContent}>
        <Typography color="textSecondary" variant="body1">
          {COPIES.subtitle}
        </Typography>

        <DividerStyled />

        <Box display="flex" flexDirection="column" gridGap={24}>
          <TextBox
            autoFocus
            fullWidth
            inputProps={{
              onFocus: e => {
                const { length } = e.target.value;
                e.target.setSelectionRange(length, length);
              }
            }}
            multiline
            noMargin
            onChange={handleTextChange}
            placeholder={COPIES.placeholder}
            rows={4}
            size="small"
            value={searchText}
            variant="outlined"
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <FPActionButton onClick={handleClose} text={strings.shared.ui.cancel} variant="outlined" />
        <FPActionButton
          disabled={!canGoSearch}
          onClick={handleExecuteSearch}
          text={COPIES.goSearchAction}
        />
      </DialogActions>
    </Dialog>
  );
};
